export default __webpack_public_path__ + "static/media/financial-3.kontrast.9524cd60.svg";